import { useEffect, useState } from 'react';
import { useDocumentStore } from '../../stores/documentStore';
import { PDFManipulator } from '../../core/PDFManipulator';
import { formatFileSize } from '../../utils/fileUtils';
import './Dialogs.css';

interface PropertiesPanelProps {
  onClose: () => void;
}

export function PropertiesPanel({ onClose }: PropertiesPanelProps) {
  const { documents, activeDocumentId } = useDocumentStore();
  const activeDoc = documents.find((d) => d.id === activeDocumentId);
  const [info, setInfo] = useState<Record<string, any> | null>(null);

  useEffect(() => {
    if (activeDoc?.arrayBuffer) {
      PDFManipulator.getDocumentInfo(activeDoc.arrayBuffer).then(setInfo).catch(console.error);
    }
  }, [activeDoc]);

  if (!activeDoc) return null;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ width: 450 }}>
        <div className="modal-header">
          <h3>ℹ️ Document Properties</h3>
          <button className="btn btn-ghost btn-icon" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)', fontSize: 'var(--text-sm)' }}>
            <div className="prop-row">
              <span className="prop-label">Filename:</span>
              <span className="prop-val">{activeDoc.filename}</span>
            </div>
            <div className="prop-row">
              <span className="prop-label">File Size:</span>
              <span className="prop-val">{formatFileSize(activeDoc.fileSize)}</span>
            </div>
            <div className="prop-row">
              <span className="prop-label">Page Count:</span>
              <span className="prop-val">{activeDoc.pageCount} pages</span>
            </div>
            {info && (
              <>
                <div className="divider-horizontal" />
                <div className="prop-row">
                  <span className="prop-label">Title:</span>
                  <span className="prop-val">{info.title || '(None)'}</span>
                </div>
                <div className="prop-row">
                  <span className="prop-label">Author:</span>
                  <span className="prop-val">{info.author || '(None)'}</span>
                </div>
                <div className="prop-row">
                  <span className="prop-label">Subject:</span>
                  <span className="prop-val">{info.subject || '(None)'}</span>
                </div>
                <div className="prop-row">
                  <span className="prop-label">Producer:</span>
                  <span className="prop-val">{info.producer || '(None)'}</span>
                </div>
                <div className="prop-row">
                  <span className="prop-label">Created:</span>
                  <span className="prop-val">{info.creationDate ? new Date(info.creationDate).toLocaleString() : '(Unknown)'}</span>
                </div>
              </>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-primary" onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
  );
}
